import { TriangleAlert } from 'lucide-react'
const AlertErrorSvg = ({ size = 16, color = '#C74028', ...props }) => (
	<TriangleAlert size={size} color={color} {...props} />
)
export default AlertErrorSvg
